import React, { useState } from 'react'
import { Row, Image, Container, Card, Button, Modal, Form, Alert } from 'react-bootstrap'

// Assets
import img_manifiesto from '../../../assets/img/logos/manifiesto.png'
import activism_2 from '../../../assets/img/activism-2.png'
import campaign_menopausia from '../../../assets/img/campaign-menopausia.png'
import rights_hands from '../../../assets/img/rights-hands.png'

// Styles
import '../../../styles/homescreen/activism.styles.scss'
import SubHeading from '../../subHeading/SubHeading'
import ActivismPillarsAccordion from './ActivismPillarsAccordion'

const GATED_DOCUMENT_SLUG = 'solicitud-menopausia-climaterio'
const GATED_DOCUMENT_GUIA_SLUG = 'guia-activismo-menstrual'
const GATED_DOCUMENT_RIGHTS_SLUG = 'derechos-menstruales-ley-organica' 

const resources = [
  {
    title: 'Manifiesto por Palestina',
    buttonLabel: 'Quiero leer',
    href: `${process.env.PUBLIC_URL}/pdfs/manifiesto-palestina.pdf`,
    image: img_manifiesto,
    imageAlt: 'Manifiesto por Palestina',
    tag: 'Manifiesto'
  },
  {
    title: 'Guía Activismo Menstrual',
    buttonLabel: 'Obtener documento',
    href: `${process.env.PUBLIC_URL}/pdfs/guia.pdf`,
    image: activism_2,
    imageAlt: 'Guía de activismo menstrual',
    tag: 'Guía',
    gated: true,
    documentSlug: GATED_DOCUMENT_GUIA_SLUG
  },
  {
    title: 'Campaña de solicitud de Atención Sanitaria en Menopausia y Climaterio',
    buttonLabel: 'Obtener documento',
    href: `${process.env.PUBLIC_URL}/pdfs/solicitud.pdf`,
    image: campaign_menopausia,
    imageAlt: 'Campaña de solicitud de Atención Sanitaria en Menopausia y Climaterio',
    tag: 'Campaña',
    gated: true,
    documentSlug: GATED_DOCUMENT_SLUG
  },
  {
    title: 'Derechos Menstruales en la Ley Orgánica 1/2023',
    buttonLabel: 'Obtener documento',
    href: `${process.env.PUBLIC_URL}/pdfs/rights.pdf`,
    image: rights_hands,
    imageAlt: 'Derechos Menstruales - Manos en solidaridad',
    tag: 'Marco legal',
    gated: true,
    documentSlug: GATED_DOCUMENT_RIGHTS_SLUG
  },
  {
    title: 'Posicionamiento: Estrategia Nacional de Menstruación Digna (México)',
    buttonLabel: 'Leer posicionamiento',
    href: `${process.env.PUBLIC_URL}/pdfs/posicionamiento-red-internacional.pdf`,
    image: `${process.env.PUBLIC_URL}/img/posicionamiento-red.png`,
    imageAlt: 'Red Internacional de Educación Menstrual - Posicionamiento',
    tag: 'Red Internacional'
  }
]

const Activism = () => {
  const [activeResource, setActiveResource] = useState(null)
  const [email, setEmail] = useState('')
  const [acceptedPrivacy, setAcceptedPrivacy] = useState(false)
  const [error, setError] = useState('')
  const [isSubmitting, setIsSubmitting] = useState(false)

  const closeModal = () => {
    setActiveResource(null)
    setEmail('')
    setAcceptedPrivacy(false)
    setError('')
    setIsSubmitting(false)
  }

  const openModal = (resource) => {
    setActiveResource(resource)
    setEmail('')
    setAcceptedPrivacy(false)
    setError('')
  }

  const handleSubmit = async (event) => {
    event.preventDefault()

    const normalizedEmail = email.trim()

    if (!normalizedEmail || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(normalizedEmail)) {
      setError('Debes indicar un email válido')
      return
    }

    if (!acceptedPrivacy) {
      setError('Debes aceptar la política de privacidad')
      return
    }

    setIsSubmitting(true)
    setError('')

    try {
      const response = await fetch('/api/document-request', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: normalizedEmail,
          acceptedPrivacy: true,
          documentSlug: activeResource.documentSlug,
          sourcePage: window.location.pathname || '/'
        })
      })
      const payload = await response.json()

      if (!response.ok) {
        throw new Error(payload.error || 'No se pudo guardar tu solicitud')
      }

      closeModal()
      window.open(payload.downloadUrl, '_blank', 'noopener,noreferrer')
    } catch (requestError) {
      setError(requestError.message || 'No se pudo guardar tu solicitud')
      setIsSubmitting(false)
    }
  }

  return (
    <Container fluid className='activism section__padding' id='activism'>
      <Row className='flex-column m-0 activism__intro'>
        <SubHeading title='Activismo' color={true} />
        <p className='normal-text text-center mt-2'>
          Para la Asociación La Vida en Rojo, hacer activismo menstrual significa incidir de manera directa en los ámbitos social y político a partir de los siguientes pilares:
        </p>
      </Row>

      <ActivismPillarsAccordion />

      <div className='activism__cards'>
        {resources.map((resource) => (
          <Card
            key={resource.title}
            data-aos='zoom-in'
            className={`activism__card border-0 ${resource.image ? 'activism__card--with-media' : 'activism__card--text-only'}`}
          >
            {resource.image && (
              <div className='activism__card-media-wrap'>
                <Image className='activism__card-media' alt={resource.imageAlt} src={resource.image} />
              </div>
            )}

            <div className='activism__card-body card-body d-flex flex-column'>
              <span className='activism__card-tag'>{resource.tag}</span>
              <h5 className='activism__card-title'>{resource.title}</h5>
              {resource.gated ? (
                <Button type='button' className='activism__card-button activity_button' onClick={() => openModal(resource)}>
                  {resource.buttonLabel}
                </Button>
              ) : (
                <Button href={resource.href} target='_blank' className='activism__card-button activity_button'>
                  {resource.buttonLabel}
                </Button>
              )}
            </div>
          </Card>
        ))}
      </div>

      <Modal
        centered
        show={Boolean(activeResource)}
        onHide={closeModal}
        dialogClassName='activism__download-modal'
        contentClassName='activism__download-modal-content'
      >
        <Modal.Header closeButton className='activism__download-modal-header'>
          <div className='activism__download-modal-heading'>
            <span className='activism__download-modal-kicker'>Documento descargable</span>
            <Modal.Title className='activism__download-modal-title'>
              {activeResource?.title}
            </Modal.Title>
            <p className='activism__download-modal-copy'>
              Déjanos tu correo para registrar la solicitud y acceder al documento en el momento.
            </p>
          </div>
        </Modal.Header>
        <Modal.Body className='activism__download-modal-body'>
          <Form onSubmit={handleSubmit}>
            <Form.Group controlId='document-request-email' className='activism__download-form-group'>
              <Form.Label className='sr-only'>Email</Form.Label>
              <div className='activism__download-input-row'>
                <Form.Control
                  type='email'
                  value={email}
                  onChange={(event) => setEmail(event.target.value)}
                  placeholder='Introduce tu email para descargarlo'
                  aria-label='Email'
                  className='activism__download-input'
                />
                <Button type='submit' className='activism__download-submit' disabled={isSubmitting}>
                  {isSubmitting ? 'Enviando...' : 'Descargar documento'}
                </Button>
              </div>
            </Form.Group>

            <Form.Group controlId='document-request-privacy' className='activism__download-privacy-group'>
              <Form.Check
                type='checkbox'
                checked={acceptedPrivacy}
                onChange={(event) => setAcceptedPrivacy(event.target.checked)}
                label={
                  <span className='activism__download-privacy-copy'>
                    He leído y acepto la <a href='/politicaprivacidad'>Política de Privacidad</a>
                  </span>
                }
              />
            </Form.Group>

            {error ? <Alert variant='danger' className='activism__download-error mb-0'>{error}</Alert> : null}
          </Form>
        </Modal.Body>
      </Modal>
    </Container>
  )
}

export default Activism
